import { render, staticRenderFns } from "./ProductImagesGallery.vue?vue&type=template&id=22ccbf46&"
import script from "./ProductImagesGallery.vue?vue&type=script&lang=js&"
export * from "./ProductImagesGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports